export default __webpack_public_path__ + "static/media/perform.387f0ee8.svg";